import type { ReactNode } from "react";
export function StatusBadge({ status, children }: { status: "neutral" | "success" | "warning" | "error"; children: ReactNode }) { return <span className={`status-badge status-${status}`}>{children}</span>; }
